<style lang="less" scoped>

</style>

<template>
    <!-- showLevel 显示的层级 2到市 3到区 -->
    <!-- selProvince 已选择的省 -->
    <!-- selCity 已选择的市 -->
    <!-- selArea 已选择的区 -->
    <!-- updateSelAreas 回调函数，返回省市区 -->
    <!-- disabledFlag 能否修改-->
    <div class="el-select-container flex">
        <div class="flex-1 margin-right-10">
            <el-select v-model="province" :size="size?size:''" clearable class="full-width" placeholder="请选择省" @change="updateCityList" :disabled="disabledFlag">
                <el-option v-for="p in provinceDataList" :key="p.id" :label="p.areaName" :value="p.areaName">
                </el-option>
            </el-select>
        </div>
        <div class="flex-1 margin-right-10">
            <el-select v-model="city"  :size="size?size:''" clearable class="full-width" placeholder="请选择市" @change="updateAreaList" :disabled="disabledFlag">
                <el-option v-for="c in cityDataList" :key="c.id" :label="c.areaName" :value="c.areaName">
                </el-option>
            </el-select>
        </div>
        <div class="flex-1 margin-right-10" v-if="showLevel == '3'">
            <el-select v-model="area"  :size="size?size:''" clearable class="full-width" placeholder="请选择区" @change="callbackAreas" :disabled="disabledFlag">
                <el-option v-for="a in areaDataList" :key="a.id" :label="a.areaName" :value="a.areaName">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ZDAreaSelect',
        props: ['showLevel', 'selProvince', 'selCity', 'selArea','size','disabledFlag'],
        data() {
            return {
                province: '',
                city: '',
                area: '',
                provinceDataList: [],
                cityDataList: [],
                areaDataList: [],
            }
        },
        methods: {
            // 获取地区
            getAreaListData(parentAreaName, areaLevel) {
                let _ = this;
                let queryData = {
                    parentAreaName: parentAreaName,
                    areaLevel: areaLevel
                };
                _.$H.get(_, _.$A.area, queryData).then(res => {
                    if (areaLevel == '1') {
                        _.provinceDataList = res.data.data.content;
                    } else if (areaLevel == '2') {
                        _.cityDataList = res.data.data.content;
                    } else {
                        _.areaDataList = res.data.data.content;
                    }
                });
            },
            // 更新城市列表
            updateCityList(province) {
                this.city = '';
                this.cityDataList = [];
                this.area = '';
                this.areaDataList = [];
                if (province == '') {
                    this.province = '';
                } else {
                    this.getAreaListData(province, "2");
                }
                this.callbackAreas();
            },
            // 更新区列表
            updateAreaList(city) {
                this.area = '';
                this.areaDataList = [];
                if (city == '') {
                    this.city = '';
                } else {
                    this.getAreaListData(city, "3");
                }
                this.callbackAreas();
            },
            // 回调
            callbackAreas() {
                this.$emit('updateSelAreas', {
                    province: this.province,
                    city: this.city,
                    area: this.area,
                })
            },
        },
        mounted() {
            // 清除内容
            this.provinceDataList =  [];
            this.cityDataList =  [];
            this.areaDataList =  [];
            // this.province = '';
            // this.city = '';
            // this.area = '';

            this.getAreaListData(null, '1');
            if (this.selProvince) {
                this.province = this.selProvince;
                this.getAreaListData(this.selProvince, '2');
            }
            if (this.selCity) {
                this.city = this.selCity;
                this.getAreaListData(this.selCity, '3');
            }
            if (this.selArea) {
                this.area = this.selArea;
            }
        }
    }
</script>